import { handleGetRequest } from "./http.service";

export interface ConversationParticipant {
  name: string;
  profileUrl: string;
  id: string;
}

export interface LatestMessage {
  _id: string;
  body: string;
  sender: string;
  createdAt: string;
  isRead: boolean;
}

export interface AdminConversation {
  _id: string;
  participants: ConversationParticipant[];
  latestMessage?: LatestMessage;
  messageCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface ConversationsResponse {
  page: number;
  limit: number;
  total: number;
  data: AdminConversation[];
}

export const adminGetAllConversations = async (params?: {
  page?: number;
  limit?: number;
}) => {
  const qs = new URLSearchParams();
  if (params?.page) qs.set("page", String(params.page));
  if (params?.limit) qs.set("limit", String(params.limit));
  const query = qs.toString() ? `?${qs}` : "";
  return handleGetRequest<ConversationsResponse>(`/conversations/admin/all${query}`);
};
